
// import React, { useState } from "react";
// import "./Admissions.css";
// import Navbar from "../Homepage/Navbar/Navbar";
// import Footer from "../Homepage/Footer/Footer";

// const Admissions = () => {
//   const [activeTab, setActiveTab] = useState("about");
//   const [showSidebar, setShowSidebar] = useState(false);

//   return (
//     <>
//       <Navbar />

// <div className="admissions-page">
//   <div className="rukdept-content-wrapper">


//         {/* Mobile Toggle */}
//         <button
//           className="rukdept-mobile-sidebar-toggle"
//           onClick={() => setShowSidebar(!showSidebar)}
//         >
//           ☰ Admissions Menu
//         </button>

//         {/* Sidebar */}
//         <aside className={`rukdept-sidebar ${showSidebar ? "show" : ""}`}>
//           <div className="rukdept-sidebar-header">
//             <h3>Admissions</h3>
//           </div>

//           <div className="rukdept-sidebar-nav">
//             <button
//               className={`rukdept-nav-item ${activeTab === "about" ? "rukdept-nav-item-active" : ""}`}
//               onClick={() => { setActiveTab("about"); setShowSidebar(false); }}
//             >
//               About Admissions
//             </button>

//             <button
//               className={`rukdept-nav-item ${activeTab === "ug" ? "rukdept-nav-item-active" : ""}`}
//               onClick={() => { setActiveTab("ug"); setShowSidebar(false); }}
//             >
//               UG Programmes
//             </button>

//             <button
//               className={`rukdept-nav-item ${activeTab === "eng" ? "rukdept-nav-item-active" : ""}`}
//               onClick={() => { setActiveTab("eng"); setShowSidebar(false); }}
//             >
//               Engineering Programmes
//             </button>

//             <button
//               className={`rukdept-nav-item ${activeTab === "pg" ? "rukdept-nav-item-active" : ""}`}
//               onClick={() => { setActiveTab("pg"); setShowSidebar(false); }}
//             >
//               PG Programmes
//             </button>
//           </div>
//         </aside>

//         {/* Content */}
//         <div className="rukdept-main-content">
//           {activeTab === "about" && <AboutAdmissions />}
//           {activeTab === "ug" && <UGAdmissions />}
//           {activeTab === "eng" && <EngineeringAdmissions />}
//           {activeTab === "pg" && <PGAdmissions />}
//         </div>

//       </div>
// </div>
//       <Footer />
//     </>
//   );
// };

// /* ---------------- ABOUT ---------------- */

// const AboutAdmissions = () => (
//   <>
//     <h2 className="rukdept-heading">Office of Admissions</h2>

//     <div className="officers-grid">
//       <div className="officer-card">
//         <img src="/telugu/Narasimhulu.JPG" />
//         <h3>Prof. N. Narasimhulu</h3>
//         <p className="designation">Director of Admissions</p>
//         <p>9182034667</p>
//         <p>drnnarasimhuluknl@gmail.com</p>
//       </div>

//       <div className="officer-card">
//         <img src="/computerscience/ravi.JPG" />
//         <h3>Dr. Gormanukonda Ravi Kumar</h3>
//         <p className="designation">Co-ordinator</p>
//         <p>8555919531</p>
//         <p>grkondaravi@gmail.com</p>
//       </div>
//     </div>

//     <div className="rukdept-message">
//       <h3 className="rukdept-message-title">About Directorate of Admissions</h3>
//       <p>
//         The Directorate of Admissions is responsible for coordinating all
//         admission activities of Rayalaseema University including UG, PG and
//         Professional programmes.
//       </p>
//       <p>
//         The office ensures transparency, fairness and compliance with APSCHE,
//         UGC and Government of Andhra Pradesh norms.
//       </p>
//     </div>

//     <div className="rukdept-highlights">
//       <div className="rukdept-highlights-title">Key Functions</div>
//       <ul className="rukdept-highlights-list">
//         <li>Coordination with APSCHE & Government portals</li>
//         <li>Supervision of counselling and merit lists</li>
//         <li>Verification of eligibility and certificates</li>
//         <li>Student grievance redressal</li>
//         <li>Fee structure implementation</li>
//         <li>Reporting to statutory bodies</li>
//       </ul>
//     </div>
//   </>
// );

// /* ---------------- UG ---------------- */

// const UGAdmissions = () => (
//   <AdmissionsTable
//     title="Undergraduate Programmes"
//     apply="https://oamdc.ap.gov.in/"
//     data={[
//       ["B.Com Computer Application", "10+2 Commerce", 50, "₹28,000", "OAMDC"],
//       ["B.Sc Computer Science", "10+2 Science", 50, "₹28,000", "OAMDC"],
//       ["B.Sc Horticulture", "10+2 Biology", 50, "₹28,000", "OAMDC"]
//     ]}
//   />
// );

// /* ---------------- ENGINEERING ---------------- */

// const EngineeringAdmissions = () => (
//   <AdmissionsTable
//     title="Engineering Programmes (B.Tech)"
//     apply="https://sche.ap.gov.in/"
//     data={[
//       ["B.Tech CSE", "10+2 PCM", 120, "₹60,000", "EAMCET"],
//       ["B.Tech AI", "10+2 PCM", 60, "₹60,000", "EAMCET"],
//       ["B.Tech ECE", "10+2 PCM", 60, "₹60,000", "EAMCET"],
//       ["B.Tech Civil", "10+2 PCM", 60, "₹60,000", "EAMCET"],
//       ["B.Tech Mechanical", "10+2 PCM", 60, "₹60,000", "EAMCET"]
//     ]}
//   />
// );

// /* ---------------- PG ---------------- */

// const PGAdmissions = () => (
//   <AdmissionsTable
//     title="Postgraduate Programmes (PG)"
//     data={[
//       ["M.A English", "Graduation with English", 35, "₹7,970", "PGCET / Merit"],
//       ["M.A Telugu", "Graduation with Telugu", 35, "₹7,970", "PGCET / Merit"],
//       ["M.A Economics", "Graduation in Economics", 35, "₹7,970", "PGCET / Merit"],
//       ["M.Com", "B.Com or equivalent", 50, "₹19,200", "PGCET"],
//       ["M.Sc Biotechnology", "B.Sc in relevant field", 40, "₹46,750", "PGCET"],
//       ["M.Sc Botany", "B.Sc Botany", 40, "₹11,860", "PGCET"],
//       ["M.Sc Zoology", "B.Sc. with Zoology and Chemistry /Industrial Chemistry ", 50, "₹11,860", "PGCET"],
//       ["M.Sc Mathematics", "B.Sc Mathematics", 35, "₹11,860", "PGCET"],
//       ["M.Sc Statistics", "BA / B.Sc. with Statistics and Mathematics ", 30, "₹11,860", "PGCET"],
//       ["M.Sc Physics", "B.Sc Physics", 35, "₹11,860", "PGCET"],
//       ["M.Sc Organic Chemistry", "B.Sc Chemistry", 30, "₹11,860 / ₹41,800", "PGCET"],
//       ["M.Sc Computer Science", "B.Sc CS / IT", 30, "₹35,750", "PGCET"],
//       ["Master of Business Administration (MBA)", "Any Degree", 60, "₹27,000", "ICET"],
//       ["Master of Computer Applications (MCA)", "B.Sc / BCA / B.Tech with Maths", 50, "₹27,000", "ICET"]
//     ]}
//   />
// );


// /* ---------------- TABLE REUSABLE ---------------- */

// const AdmissionsTable = ({ title, apply, data }) => (
//   <>
//     <h2 className="rukdept-heading">{title}</h2>

//     {apply && (
//       <p className="apply-link">
//         Apply Here: <a href={apply} target="_blank">{apply}</a>
//       </p>
//     )}

//     <table className="admission-table">
//       <thead>
//         <tr>
//           <th>Programme</th>
//           <th>Eligibility</th>
//           <th>Intake</th>
//           <th>Fees</th>
//           <th>Process</th>
//         </tr>
//       </thead>
//       <tbody>
//         {data.map((row, i) => (
//           <tr key={i}>
//             <td>{row[0]}</td>
//             <td>{row[1]}</td>
//             <td>{row[2]}</td>
//             <td>{row[3]}</td>
//             <td>{row[4]}</td>
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   </>
// );

// export default Admissions;
import React, { useState } from "react";
import "./Admissions.css";
import Navbar from "../Homepage/Navbar/Navbar";
import Footer from "../Homepage/Footer/Footer";

const tabs = [
  { id: "about", label: "About Admissions" },
  { id: "ug", label: "UG Programmes" },
  { id: "eng", label: "Engineering Programmes" },
  { id: "pg", label: "PG Programmes" },
];

const Admissions = () => {
  const [activeTab, setActiveTab] = useState("about");
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      <Navbar />

      <div className="admissions-page">

        {/* Mobile Toggle */}
        <button
          className="admissions-mobile-toggle"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          ☰ Admissions Menu
        </button>

        <div className="admissions-layout">

          {/* Sidebar */}
          <aside className={`admissions-sidebar ${mobileOpen ? "open" : ""}`}>
            <div className="admissions-sidebar-header">
              <h3>Admissions</h3>
            </div>

            <nav className="admissions-sidebar-nav">
              {tabs.map(tab => (
                <button
                  key={tab.id}
                  className={`admissions-nav-item ${activeTab === tab.id ? "active" : ""}`}
                  onClick={() => {
                    setActiveTab(tab.id);
                    setMobileOpen(false);
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </nav>
          </aside>

          {/* Content */}
          <main className="admissions-content">
            {activeTab === "about" && <AboutAdmissions />}
            {activeTab === "ug" && <UGAdmissions />}
            {activeTab === "eng" && <EngineeringAdmissions />}
            {activeTab === "pg" && <PGAdmissions />}
          </main>

        </div>
      </div>

      <Footer />
    </>
  );
};

/* ---------------- ABOUT ---------------- */

const AboutAdmissions = () => (
  <>
    <h2 className="admissions-heading">Office of Admissions</h2>

    <div className="admissions-officers">
      <div className="admissions-officer-card">
        <img src="/telugu/Narasimhulu.JPG" alt="" />
        <h3>Prof. N. Narasimhulu</h3>
        <p>Director of Admissions</p>
        <p>9182034667</p>
        <p>drnnarasimhuluknl@gmail.com</p>
      </div>

      <div className="admissions-officer-card">
        <img src="/computerscience/ravi.JPG" alt="" />
        <h3>Dr. Gormanukonda Ravi Kumar</h3>
        <p>Co-ordinator</p>
        <p>8555919531</p>
        <p>grkondaravi@gmail.com</p>
      </div>
    </div>

    <p className="admissions-text">
      The Directorate of Admissions coordinates all UG, PG and Professional programme
      admissions ensuring transparency and compliance with APSCHE, UGC and Government norms.
    </p>
  </>
);

/* ---------------- UG ---------------- */

const UGAdmissions = () => (
  <AdmissionsTable
    title="Undergraduate Programmes"
    apply="https://oamdc.ap.gov.in/"
    data={[
      ["B.Com Computer Application", "10+2 Commerce", 50, "₹28,000", "OAMDC"],
      ["B.Sc Computer Science", "10+2 Science", 50, "₹28,000", "OAMDC"],
      ["B.Sc Horticulture", "10+2 Biology", 50, "₹28,000", "OAMDC"],
    ]}
  />
);

/* ---------------- ENGINEERING ---------------- */

const EngineeringAdmissions = () => (
  <AdmissionsTable
    title="Engineering Programmes"
    apply="https://sche.ap.gov.in/"
    data={[
      ["B.Tech CSE", "10+2 PCM", 120, "₹60,000", "EAMCET"],
      ["B.Tech AI", "10+2 PCM", 60, "₹60,000", "EAMCET"],
      ["B.Tech ECE", "10+2 PCM", 60, "₹60,000", "EAMCET"],
      ["B.Tech Civil", "10+2 PCM", 60, "₹60,000", "EAMCET"],
      ["B.Tech Mechanical", "10+2 PCM", 60, "₹60,000", "EAMCET"]
    ]}
  />
);

/* ---------------- PG ---------------- */

const PGAdmissions = () => (
  <AdmissionsTable
    title="Postgraduate Programmes"
    data={[
      ["M.A English", "Graduation with English", 35, "₹7,970", "PGCET / Merit"],
      ["M.A Telugu", "Graduation with Telugu", 35, "₹7,970", "PGCET / Merit"],
      ["M.A Economics", "Graduation in Economics", 35, "₹7,970", "PGCET / Merit"],
      ["M.Com", "B.Com or equivalent", 50, "₹19,200", "PGCET"],
      ["M.Sc Biotechnology", "B.Sc in relevant field", 40, "₹46,750", "PGCET"],
      ["M.Sc Botany", "B.Sc Botany", 40, "₹11,860", "PGCET"],
      ["M.Sc Zoology", "B.Sc. with Zoology and Chemistry /Industrial Chemistry ", 50, "₹11,860", "PGCET"],
      ["M.Sc Mathematics", "B.Sc Mathematics", 35, "₹11,860", "PGCET"],
      ["M.Sc Statistics", "BA / B.Sc. with Statistics and Mathematics ", 30, "₹11,860", "PGCET"],
      ["M.Sc Physics", "B.Sc Physics", 35, "₹11,860", "PGCET"],
      ["M.Sc Organic Chemistry", "B.Sc Chemistry", 30, "₹11,860 / ₹41,800", "PGCET"],
      ["M.Sc Computer Science", "B.Sc CS / IT", 30, "₹35,750", "PGCET"],
      ["Master of Business Administration (MBA)", "Any Degree", 60, "₹27,000", "ICET"],
      ["Master of Computer Applications (MCA)", "B.Sc / BCA / B.Tech with Maths", 50, "₹27,000", "ICET"]
    ]}
  />
);

/* ---------------- TABLE ---------------- */

const AdmissionsTable = ({ title, apply, data }) => (
  <>
    <h2 className="admissions-heading">{title}</h2>

    {apply && (
      <p className="apply-link">
        Apply Here: <a href={apply} target="_blank" rel="noreferrer">{apply}</a>
      </p>
    )}

    <table className="admissions-table">
      <thead>
        <tr>
          <th>Programme</th>
          <th>Eligibility</th>
          <th>Intake</th>
          <th>Fees</th>
          <th>Process</th>
        </tr>
      </thead>
      <tbody>
        {data.map((r, i) => (
          <tr key={i}>
            <td>{r[0]}</td>
            <td>{r[1]}</td>
            <td>{r[2]}</td>
            <td>{r[3]}</td>
            <td>{r[4]}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </>
);

export default Admissions;
